import { formatStringToDate } from "go-core/components/Formatters/FormatDate";
import {
	FILTER_SEPARATOR,
	FILTER_VALUE_SEPARATOR,
	NEW_WAY_TO_ENCODING_FILTER_SIGN,
} from "go-list/core/components/Filter/services";
import { OrderPreparationStatusName } from "../../../../../services/Api/Organization/types";
import { apiPublic } from "../../../../../services/Api/Public/apiPublic";
import { NumberOrderApi } from "../../../../../services/Api/Public/types";
import { getNumberSystemFilteredItemsByStatuses } from "../utils";

export class NumberSystemSynchronizer {
	items: NumberOrderApi[];
	lastUpdatedAt?: string;
	size: number;

	constructor() {
		this.items = [];
		const startDate = new Date();
		startDate.setHours(new Date().getHours() - 2);
		this.lastUpdatedAt = startDate.toISOString();
		this.size = 20;
	}

	async getAll(dateTo: string, organizationId: number): Promise<NumberOrderApi[]> {
		const baseFilter = `${NEW_WAY_TO_ENCODING_FILTER_SIGN}organization_id=${organizationId}${FILTER_SEPARATOR}storno=false${FILTER_SEPARATOR}`;
		let finalFilter = "";
		let currentFilter = baseFilter;
		if (this.lastUpdatedAt) {
			currentFilter = `${baseFilter}updated_at|bt=${this.lastUpdatedAt}${FILTER_VALUE_SEPARATOR}${dateTo}`;
			finalFilter = currentFilter;
		}
		const allItems: NumberOrderApi[] = [];
		let fetchingFinished = false;
		while (!fetchingFinished) {
			const params: Record<string, any> = {
				page: 0,
				size: this.size,
				sort: "id",
				f: btoa(unescape(encodeURIComponent(finalFilter))),
			};
			const newItems = await apiPublic.getOrderNumbers(params);
			allItems.push(...newItems);
			if (newItems.length < this.size) {
				fetchingFinished = true;
			}
			const maxId = Math.max(...allItems.map(({ id }) => id));
			if (maxId) {
				finalFilter = `${currentFilter}${FILTER_SEPARATOR}id|gt=${maxId}`;
			} else {
				finalFilter = currentFilter;
			}
		}
		return allItems;
	}

	async sync(organizationId: number): Promise<NumberOrderApi[]> {
		const now = new Date();
		const allItems = await this.getAll(now.toISOString(), organizationId);
		this.items = [
			...allItems.filter((item) => !this.items.find((itemFromAll) => itemFromAll.id === item.id)),
			...this.items.map((item) => {
				const possibleUpdatedItem = allItems.find((itemFromAll) => itemFromAll.id === item.id);
				if (possibleUpdatedItem) {
					return possibleUpdatedItem;
				}
				return item;
			}),
		];
		this.items = getNumberSystemFilteredItemsByStatuses(this.items, [
			OrderPreparationStatusName.IN_PROGRESS,
			OrderPreparationStatusName.NEW,
			OrderPreparationStatusName.PACKED,
			OrderPreparationStatusName.READY,
		]);
		this.items.sort(
			(a, b) => formatStringToDate(b.created_at).getTime() - formatStringToDate(a.created_at).getTime()
		);
		this.lastUpdatedAt = new Date(now.getTime() - 1000).toISOString();
		return this.items;
	}
}
